import { useEffect, useState } from 'react';

import { logger } from '../../../../common/utils/logger';
import { fetchImages, type ImageResult } from './fetch-images';

export const useImages: ({
	searchQuery,
	cloudId,
	workspaceId,
	product,
}: {
	searchQuery: string;
	cloudId: string;
	workspaceId: string;
	product: string;
}) => {
	images: ImageResult[] | null;
	loading: boolean;
	error: boolean;
} = ({ searchQuery, cloudId, workspaceId, product }) => {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [images, setImages] = useState<ImageResult[] | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				setError(false);

				const data = await fetchImages({
					searchQuery,
					cloudId,
					workspaceId,
					product,
				});
				const filteredImages = data.images.filter((image) => image.url && image.thumbnailUrl);
				setImages(filteredImages);
			} catch (e) {
				logger.error({ error: e, functionName: 'useImages' });
				setError(true);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		images,
		loading,
		error,
	};
};
